import * as tslib_1 from "tslib";
import { AfterViewInit, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { WhatsNewService } from '../shared/services/whats-new.service';
import { GlobalSettingsService } from '../shared/services/global-settings.service';
import { environment } from '../../environments/environment';
var WhatsnewComponent = /** @class */ (function () {
    // localStorageInfo = this._globalSettingsService.localStorageInfo$;
    function WhatsnewComponent(dialogRef, whatsnewService, _globalSettingsService) {
        this.dialogRef = dialogRef;
        this.whatsnewService = whatsnewService;
        this._globalSettingsService = _globalSettingsService;
        // whatsnewVersion: string = null;
        this.whatsnewTitle = null;
        this.whatsnewText = null;
        this.whatsnewURL = null;
    }
    WhatsnewComponent.prototype.ngOnInit = function () {
        /* const response = await this.whatsnewService.getWhatsNew('1.4.3');
        this.whatsnewTitle = response.title;
        this.whatsnewText = response.text;
        this.whatsnewURL = response.url; */
        /* this._globalSettingsService.loadInfo();
        this.localStorageInfo.subscribe(val => {
          console.log(val);
          if (val && val.whatsNewVersion) {
            this.whatsnewVersion = val.whatsNewVersion;
          }
        }); */
        // console.log('localStorageInfo: ', this.localStorageInfo);
    };
    WhatsnewComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.whatsnewService.getWhatsNew(environment.version)];
                    case 1:
                        response = _a.sent();
                        if (!response.whatsnew_text) {
                            this.dismiss();
                        }
                        this.whatsnewTitle = response.title;
                        this.whatsnewText = response.whatsnew_text;
                        this.whatsnewURL = response.whatsnew_more_url;
                        return [2 /*return*/];
                }
            });
        });
    };
    WhatsnewComponent.prototype.dismiss = function () {
        // using the injected ModalController this page
        // can "dismiss" itse1lf and optionally pass back data
        this.dialogRef.close({
            dismissed: true
        });
        // this.whatsnewService.displayedWhatsNew();
    };
    return WhatsnewComponent;
}());
export { WhatsnewComponent };
